import PropTypes from "prop-types";

const highlightTerm = (match, searchTerm) => {
  const regex = new RegExp(searchTerm, "gi");
  return match.replace(regex, "<mark>$&</mark>");
};

const Suggestion = ({ searchTerm, list, searchOnSuggestion }) => {
  if (!list?.length) {
    return null;
  }
  return (
    <div className="w-full absolute top-10 max-h-[300px] overflow-auto bg-[#f5f5f5]">
      <ul>
        {list?.map(item => (
          <li
            key={item.name}
            className="bg-[#f5f5f5] hover:bg-[#6c89ad] hover:text-[#fff] text-[12px]"
          >
            <button
              type="button"
              className="w-full text-left p-4 cursor-pointer"
              onClick={() => searchOnSuggestion(item, list)}
            >
              <span
                dangerouslySetInnerHTML={{
                  __html: highlightTerm(item.name, searchTerm),
                }}
              ></span>
              {/* {item.name} */}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

Suggestion.propTypes = {
  searchTerm: PropTypes.string,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      ProductCategory_s: PropTypes.string,
    })
  ),
  searchOnSuggestion: PropTypes.func,
};

export default Suggestion;
